import React,{useRef} from "react";
import { useTranslate } from 'react-redux-multilingual'
import { Modal } from "react-bootstrap";
import AddArticlePriceForm from './AddArticlePriceForm'

const AddArticlePriceModal = (props) =>{
    const t = useTranslate()
    const amountInputRef = useRef(null)

    return(
        <Modal size="md" show={props.show} onHide={() => props.onCancel()} onEntered={() => amountInputRef.current && amountInputRef.current.focus()}>
            <Modal.Header closeButton>
                <Modal.Title>{t('setArticlePrice')}{props.articleName ? ' — '+props.articleName : ''}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <AddArticlePriceForm
                    posid={props.posid}
                    authParam={props.authParam}
                    onValidate={props.onValidate}
                    amountInputRef={amountInputRef}
                />
            </Modal.Body>
        </Modal>
    )
}

export default AddArticlePriceModal;
